import { Modal } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ZLButton from '../zl-button/zl-button';
import Heading, { HeadingSize } from '../heading/heading';
import { IApplicationState } from '../../store';
import { useSelector, useDispatch } from 'react-redux';
import { actionCreators as UIActions } from '../../store/UI';

const ErrorDisplay: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const errorKey = useSelector((state: IApplicationState) => state.ui.errorKey);
    const additionalMessage = useSelector((state: IApplicationState) => state.ui.errorMessage);

    useEffect(() => {
        if (errorKey) setShowModal(true);
    }, [errorKey]);

    const handleCancel = () => {
        dispatch(UIActions.clearError());
        setShowModal(false);
    };

    const translation = errorKey ? <Paragraph>{t(`${errorKey}`)}</Paragraph> : <React.Fragment />;
    const message = additionalMessage ? (
        <Paragraph>
            {additionalMessage.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))}
        </Paragraph>
    ) : (
        <React.Fragment />
    );

    return (
        <Modal
            centered
            open={showModal}
            maskClosable={false}
            closable={false}
            footer={[
                <ZLButton key="ok" onClick={handleCancel}>
                    <Text>{t('okay')}</Text>
                </ZLButton>,
            ]}
            className="error-modal"
        >
            <Heading level={HeadingSize.One}>{t('errors.errorOccurred')}</Heading>
            {translation}
            {message}
        </Modal>
    );
};

export default ErrorDisplay;
